import styled from 'styled-components';

import { mediaConfined, mediaSmallOrTiny } from '@xingternal/layout-tokens';
import { space4XL } from '@xingternal/tokens';
import { Column } from '@xingternal/xing-grid';

import { CultureTitle } from './culture-title';

export const StyledCultureTitle = styled(CultureTitle)`
  @media ${mediaSmallOrTiny} {
    display: none;
  }
`;

export const StyledMobileCultureTitle = styled(CultureTitle)`
  @media ${mediaConfined} {
    display: none;
  }
`;

export const StyledCultureColumnsWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media (${mediaConfined}) {
    flex-direction: row;
    gap: ${space4XL};
  }
`;

export const StyledInfoColumn = styled(Column)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const StyledCultureInfoWrapper = styled.div`
  flex: 1;
`;

export const StyledCompassWithLegend = styled(Column)`
  &&& {
    padding: 0;
  }
`;
